<template>
  <div class="app-wrapper">
    <div class="sidebar-container">
      <SideMenu />
    </div>

    <div class="main-container">
      <div class="fixed-header">
        <TopHeader />
      </div>

      <div class="app-main">
        <transition name="fade-transform" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu.vue";
import TopHeader from "@/components/TopHeader.vue";

export default {
  name: "Layout",
  components: {
    SideMenu,
    TopHeader,
  },
};
</script>

<style scoped>
.app-wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.sidebar-container {
  width: 240px;
  height: 100%;
  background-color: #fff;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.05);
  z-index: 100;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5; /* 整体灰色背景，为了凸显内部的白卡片 */
  overflow: hidden;
}

.app-main {
  flex: 1;
  /* padding: 20px; */
  overflow-y: auto;
}

.content-box {
  background: #fff;
  padding: 20px;
  min-height: 100%;
  border-radius: 4px;
}
</style>
